import { render, staticRenderFns } from "./SectionView.vue?vue&type=template&id=22351c06&scoped=true"
import script from "./SectionView.vue?vue&type=script&lang=js"
export * from "./SectionView.vue?vue&type=script&lang=js"
import style0 from "./SectionView.vue?vue&type=style&index=0&id=22351c06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22351c06",
  null
  
)

export default component.exports